<template>
  <div class="fu">
    <div class="fu-head">
      <div class="fu-title">{{ title }}</div>
      <div class="fu-sub" v-if="subtitle">{{ subtitle }}</div>
    </div>

    <div class="fu-body">
      <b-form-file
          v-model="innerFile"
          :accept="accept"
          :disabled="isBtnsDisabled"
          browse-text="انتخاب فایل"
          placeholder="فایلی انتخاب نشده"
          class="w-100"
      />

      <div class="fu-actions">
        <b-button
            type="button"
            variant="primary"
            class="fu-btn"
            :disabled="isBtnsDisabled || !pickedFile"
            @click="$emit('upload')"
        >
          آپلود
        </b-button>

        <b-button
            type="button"
            variant="outline-secondary"
            class="fu-btn"
            :disabled="isBtnsDisabled"
            @click="$emit('reset')"
        >
          پاک کردن
        </b-button>
      </div>

      <div class="fu-progress" v-if="pickedFile || uploaded > 0">
        <div class="fu-progress-top">
          <div class="fu-file">
            <div class="fu-file-name">{{ fileName }}</div>
            <div class="fu-file-size">{{ formatFileSize(totalSize || pickedSize) }}</div>
          </div>

          <div class="fu-pct">
            {{ safePct }}%
          </div>
        </div>

        <b-progress height="8px" :value="safePct" max="100" class="rounded" />

        <div class="fu-stats">
          <div class="fu-stat">
            <div class="fu-stat-k">آپلود شده</div>
            <div class="fu-stat-v">{{ formatFileSize(uploadedBytes) }}</div>
          </div>

          <div class="fu-stat">
            <div class="fu-stat-k">سرعت</div>
            <div class="fu-stat-v">{{ formatSpeed(speedSpan) }}</div>
          </div>

          <div class="fu-stat">
            <div class="fu-stat-k">زمان باقی</div>
            <div class="fu-stat-v">{{ formatTime(etaSpan) }}</div>
          </div>
        </div>

        <b-alert v-if="done" show variant="success" class="mt-2 mb-0">
          {{ done }}
        </b-alert>

        <b-alert v-if="errorAlert" show variant="danger" class="mt-2 mb-0">
          خطا در آپلود
        </b-alert>
      </div>
    </div>
  </div>
</template>

<script>
import { BFormFile, BButton, BProgress, BAlert } from "bootstrap-vue"

export default {
  name: "FileUploader",
  components: { BFormFile, BButton, BProgress, BAlert },
  props: {
    title: { type: String, default: "آپلود" },
    subtitle: { type: String, default: "" },
    accept: { type: String, default: "" },
    file: { type: [File, Object, Array], default: null },

    uploaded: { type: Number, default: 0 },
    uploadedBytes: { type: Number, default: 0 },
    totalSize: { type: Number, default: 0 },
    speedSpan: { type: Number, default: 0 },
    etaSpan: { type: Number, default: 0 },

    done: { type: [String, Boolean, Object], default: null },
    errorAlert: { type: Boolean, default: false },
    isBtnsDisabled: { type: Boolean, default: false },
  },
  data() {
    return {
      innerFile: null,
    }
  },
  computed: {
    pickedFile() {
      const f = this.innerFile
      return !!(f instanceof File ? f : Array.isArray(f) ? f[0] : f)
    },
    pickedSize() {
      const f = this.getFirstFile(this.innerFile)
      return Number(f?.size || 0) || 0
    },
    fileName() {
      const f = this.getFirstFile(this.innerFile)
      return String(f?.name || "")
    },
    safePct() {
      const n = Number(this.uploaded)
      if (!Number.isFinite(n)) return 0
      return Math.max(0, Math.min(100, Math.round(n)))
    },
  },
  watch: {
    file: {
      immediate: true,
      handler(v) {
        if (!v) {
          this.innerFile = null
          return
        }
        if (this.innerFile) return
        this.innerFile = v
      },
    },
    innerFile(v) {
      this.$emit("select", this.getFirstFile(v) || null)
    },
  },
  methods: {
    getFirstFile(v) {
      if (!v) return null
      if (v instanceof File) return v
      if (Array.isArray(v)) return v[0] || null
      return v
    },
    formatFileSize(bytes) {
      const n = Number(bytes || 0)
      if (!Number.isFinite(n) || n <= 0) return "0 B"
      const k = 1024
      const sizes = ["B", "KB", "MB", "GB", "TB"]
      const i = Math.min(sizes.length - 1, Math.floor(Math.log(n) / Math.log(k)))
      const val = n / Math.pow(k, i)
      return `${val.toFixed(val >= 100 ? 0 : val >= 10 ? 1 : 2)} ${sizes[i]}`
    },
    formatSpeed(kbPerSec) {
      const n = Number(kbPerSec || 0)
      if (!Number.isFinite(n) || n <= 0) return "0 KB/s"
      if (n >= 1024) return `${(n / 1024).toFixed(2)} MB/s`
      return `${n.toFixed(2)} KB/s`
    },
    formatTime(seconds) {
      const n = Number(seconds || 0)
      if (!Number.isFinite(n) || n <= 0) return "0s"
      if (n < 60) return `${Math.round(n)}s`
      const m = Math.floor(n / 60)
      const s = Math.round(n % 60)
      return `${m}m ${s}s`
    },
  },
}
</script>

<style scoped>
.fu {
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  background: #fff;
  overflow: hidden;
}
.fu-head {
  padding: 10px 12px;
  border-bottom: 1px solid #f1f5f9;
  background: #fafafa;
}
.fu-title {
  font-weight: 900;
  font-size: 13px;
  color: #111827;
}
.fu-sub {
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
}
.fu-body {
  padding: 12px;
}
.fu-actions {
  margin-top: 10px;
  display: flex;
  gap: 10px;
}
.fu-btn {
  height: 44px;
  border-radius: 12px;
  font-weight: 900;
  padding: 0 14px;
}
.fu-progress {
  margin-top: 12px;
}
.fu-progress-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 8px;
}
.fu-file-name {
  font-size: 12px;
  font-weight: 900;
  color: #111827;
  max-width: 360px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.fu-file-size {
  font-size: 11px;
  color: #6b7280;
  margin-top: 2px;
}
.fu-pct {
  font-size: 12px;
  font-weight: 900;
  color: #111827;
  direction: ltr;
}
.fu-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin-top: 10px;
}
.fu-stat {
  border: 1px solid #eef2f7;
  border-radius: 12px;
  padding: 8px 10px;
  background: #fbfdff;
}
.fu-stat-k {
  font-size: 11px;
  color: #6b7280;
  font-weight: 800;
}
.fu-stat-v {
  font-size: 12px;
  font-weight: 900;
  color: #111827;
  margin-top: 3px;
  direction: ltr;
  text-align: left;
}
@media (max-width: 576px) {
  .fu-stats {
    grid-template-columns: 1fr;
  }
}
</style>
